import { productNameToMpvId } from '@99designs/routing';

export function isSdpEnabled(productName: string | undefined, locale: string) {
    if (!productName) return false;

    return (
        isEnabledForAllLocales(productName) ||
        (isSupportedInProductAndLocale(productName, locale) &&
            hasValidMpvIdMapping(productName, locale))
    );
}

export function isEnabledForAllLocales(productName: string) {
    const enabledForAllLocales = ['logo-essential'];
    if (enabledForAllLocales.includes(productName)) {
        return true;
    }
    return false;
}

export function isSupportedInProductAndLocale(productName: string, locale: string) {
    switch (locale) {
        case 'en-US':
        case 'en-AU': {
            const enabledProducts = [
                'brochure-design',
                'menu-design',
                'flyer-design',
                'postcard-design',
                'vinyl-banner-design',
                'business-card-design',
            ];

            return enabledProducts.includes(productName);
        }
        case 'en-GB': {
            const enabledProducts = ['business-card-design'];
            return enabledProducts.includes(productName);
        }
        case 'en-CA': {
            const enabledProducts = [
                'business-card-design',
                'brochure-design',
                'menu-design',
                'flyer-design',
                'postcard-design',
                'vinyl-banner-design',
            ];
            return enabledProducts.includes(productName);
        }
        default:
            return false;
    }
}

export function hasValidMpvIdMapping(productName: string, locale: string) {
    const mpvId = productNameToMpvId(locale, productName);
    return mpvId !== undefined;
}
